/* Tiloa — galerie produit : un cadre carré, quelle que soit la source.

   Mesuré avant correction sur la fiche Tiloa Duck, à 1440 px : les cadres de
   la galerie prenaient le format de leur média. Cinq slides en 729 x 729, une
   en 411 x 729 (la vidéo, tournée en 9:16) et une en 729 x 701. Résultat : la
   galerie changeait de forme à chaque glissement et toute la colonne d'achat
   se décalait verticalement — le prix et le bouton bougeaient sous le doigt.

   La consigne était un format 1:1 « sans cropper brutalement », le produit
   restant entièrement visible. Les deux à la fois ne se règlent pas avec une
   seule valeur d'object-fit :

     - un média déjà carré peut remplir le cadre (cover) : il n'y a rien à
       perdre, et le cadre est rempli au pixel ;
     - un média vertical ou panoramique doit rester entier (contain). Le cadre
       carré laisse alors des zones libres. Les remplir d'un aplat crème
       donnait exactement ce que la consigne refusait : un petit produit au
       milieu d'un énorme cadre.

   D'où ce script : il lit le format réel de chaque média et le classe. Pour
   ceux qui ne sont pas carrés, il pose en fond une copie floutée du média
   lui-même. Le carré se referme sur une matière tirée de l'image, pas sur une
   dalle vide, et aucun pixel du produit n'est coupé.

   Aucune requête supplémentaire : le fond réutilise l'URL déjà chargée. */
(function () {
  var CARRE = 0.02; // tolérance : 1946x1871 (1,04) n'est pas carré, 632x632 l'est

  function media(item) {
    return item.querySelector('video, img');
  }

  /* Le format d'origine, sans attendre le chargement : le thème écrit toujours
     width et height sur ses balises, et c'est la seule source fiable avant que
     l'image arrive. On retombe sur les dimensions naturelles ensuite. */
  function format(el) {
    var w = parseFloat(el.getAttribute('width')) || el.naturalWidth || el.videoWidth || 0;
    var h = parseFloat(el.getAttribute('height')) || el.naturalHeight || el.videoHeight || 0;
    return w && h ? w / h : 0;
  }

  /* L'URL à flouter derrière un média non carré. Pour une vidéo, c'est son
     image d'attente : le thème la rend avant lecture, et elle reste la seule
     image disponible tant que la vidéo n'a pas démarré. */
  function fond(item, el) {
    if (el.tagName === 'IMG') return el.currentSrc || el.src || '';
    var poster = el.getAttribute('poster');
    if (poster) return poster;
    var apercu = item.querySelector('img');
    return apercu ? apercu.currentSrc || apercu.src || '' : '';
  }

  function classer(item) {
    var el = media(item);
    if (!el) return;
    var r = format(el);
    if (!r) return; // format inconnu : on ne décide pas à sa place

    if (Math.abs(r - 1) <= CARRE) {
      item.setAttribute('data-tiloa-cadre', 'carre');
      item.style.removeProperty('--tiloa-fond');
      return;
    }

    item.setAttribute('data-tiloa-cadre', 'libre');
    var url = fond(item, el);
    // Une URL sans guillemets casserait la déclaration CSS sur une adresse
    // contenant une parenthèse ou une espace.
    if (url) item.style.setProperty('--tiloa-fond', 'url("' + url.replace(/"/g, '%22') + '")');
  }

  function passe(racine) {
    (racine || document).querySelectorAll('.product__media-item').forEach(classer);
  }

  passe();
  document.addEventListener('DOMContentLoaded', function () { passe(); });

  /* Le thème remplace la galerie entière quand la variante change, et pose de
     nouvelles slides sans prévenir. On reclasse ce qui arrive. */
  var cible = document.querySelector('media-gallery, .product__media-wrapper');
  if (cible && typeof MutationObserver === 'function') {
    var obs = new MutationObserver(function (lots) {
      for (var i = 0; i < lots.length; i++) {
        if (lots[i].addedNodes.length) { passe(cible); return; }
      }
    });
    obs.observe(cible, { childList: true, subtree: true });
  }

  /* Une image dont le thème n'aurait pas écrit les dimensions se classe à son
     chargement plutôt que jamais. */
  document.addEventListener('load', function (e) {
    var img = e.target;
    if (img && img.tagName === 'IMG' && img.closest) {
      var item = img.closest('.product__media-item');
      if (item && !item.getAttribute('data-tiloa-cadre')) classer(item);
    }
  }, true);
})();

/* Clavier : le média qui reçoit le focus est amené à l'écran dans le
   carrousel mobile (sinon le focus tombait hors de la vue). Seulement au
   clavier (:focus-visible) et seulement à l'horizontale : un toucher sur
   Android ou le focus rendu à la fermeture de la visionneuse ne doivent
   jamais faire défiler la page. */
document.addEventListener('focusin', function (e) {
  var t = e.target && e.target.closest && e.target.closest('.product__media-list .product__media-toggle');
  if (!t) return;
  try { if (!t.matches(':focus-visible')) return; } catch (err) { return; }
  var li = t.closest('.product__media-item');
  var liste = li && li.parentElement;
  if (!liste || liste.scrollWidth <= liste.clientWidth) return;
  liste.scrollTo({ left: li.offsetLeft });
});
